import React from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { SELF_PAY_EVENTS } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/mixpanelConstants'
import { useEapToHpiBannerState } from '@lyrahealth-inc/shared-app-logic/src/features/eligibility/hooks/useEapHpiBannerState'
import { EAP_TO_HPI_LINK_DESTINATION } from '@lyrahealth-inc/shared-app-logic/src/features/eligibility/hooks/useGetEapToHpiEligibilityText'
import { createEapHpiDestinationWebLink } from '@lyrahealth-inc/shared-app-logic/src/features/eligibility/utils'
import { EapToHpiBanner as EapToHpiBannerComponent } from '@lyrahealth-inc/ui-core-crossplatform/src/molecules/eapToHpiBanner/EapToHpiBanner'

import { getIsEapToHpiFeatureEnabled } from '../../../data/featureFlags/featureFlagSelectors'
import { trackEventWithObj } from '../../../data/mixpanel'
import { useAppDispatch } from '../../../data/storeConfiguration/store'
import { getEapHpiHomebaseBannerNotificationState, getId } from '../../../data/user/userSelectors'
import { axiosInstance } from '../../http/axiosInstance'
import { triggerEapToHpiBannerCtaAction } from '../banner/banner-actions'

export const EapToHpiBanner: React.FC = () => {
  const lyraId = useSelector(getId)
  const isEapToHpiBannerFeatureEnabled = useSelector(getIsEapToHpiFeatureEnabled)
  const eapHpiNotificationState = useSelector(getEapHpiHomebaseBannerNotificationState)
  const {
    isEapHpiBannerStateLoading,
    isEapHpiBannerVisible,
    sessionsRemaining,
    notificationType,
    dependentName,
    providerLyraId,
    sessionType,
    childLyraId,
    flowAs,
  } = useEapToHpiBannerState({
    userLyraId: lyraId,
    axiosInstance,
    isEapToHpiBannerFeatureEnabled,
    eapHpiNotificationState,
  })
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const onPressLink = (linkDestination: EAP_TO_HPI_LINK_DESTINATION) => {
    trackEventWithObj({ event: SELF_PAY_EVENTS.CLICK_SELF_PAY_TRANSITION_HOMEBASE_BANNER })
    if (providerLyraId != null) {
      // providerId is required as it is used as a path param in the url and should always be present
      const routeDestination = createEapHpiDestinationWebLink({
        linkDestination,
        providerId: providerLyraId,
        sessionType,
        childLyraId,
      })
      navigate(routeDestination)
    }

    dispatch(triggerEapToHpiBannerCtaAction())
  }

  const onClose = () => {
    // TODO: Implement hide behavior in ACCOUNT-3734
  }

  if (isEapHpiBannerStateLoading || !isEapHpiBannerVisible) {
    return null
  }

  return (
    <EapToHpiBannerComponent
      onPressLink={onPressLink}
      onClose={onClose}
      sessionsRemaining={sessionsRemaining}
      dependentName={dependentName}
      flowAs={flowAs}
      notificationType={notificationType}
      showCloseIcon={false}
    />
  )
}
